export function trackEvent(eventName: string, eventData: any) {
    if (!window["analytics"]) return;

    window["analytics"].track(eventName, eventData);
}

export const hubspotPortalId = "6577365";